// extracted by mini-css-extract-plugin
export var avatarContainer = "_h6-0";
export var avatarTypingWave = "_h6-i";
export var gray = "_h6-f";
export var green = "_h6-c";
export var icon = "_h6-9";
export var image = "_h6-1";
export var lg = "_h6-6";
export var md = "_h6-5";
export var presenceDot = "_h6-b";
export var red = "_h6-d";
export var sm = "_h6-4";
export var status = "_h6-a";
export var typingDot = "_h6-h";
export var typingPill = "_h6-g";
export var xl = "_h6-7";
export var xs = "_h6-3";
export var xxl = "_h6-8";
export var xxs = "_h6-2";
export var yellow = "_h6-e";